import { useEffect, useRef } from 'react';

const CustomPopover = ({children, options, isOpen, setIsOpen}) => {
    const dropdownRef = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
  return (
    <div ref={dropdownRef} className="relative">
      <div>
        {children}
      </div>
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => {
                setIsOpen(false);
                option?.click()
              }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-gray-100 `}
            >
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export { CustomPopover };
